import logo from "@/assets/logo/logo.png";

export default function Header({ title }: { title: string }) {
  return (
    <header className="text-center relative z-50">
      <div className="flex items-center justify-center gap-6">
        <img src={logo} alt="Logo" className="h-8 sm:h-auto" />
        <h1 className="text-lg sm:text-4xl font-bold">{title}</h1>
      </div>
    </header>
  );
}
